export enum THEME {
    LIGHT,
    DARK,
    AUTO,
}
